import { type HttpClient } from '../useHttpClient';

export const uploadUsers =
  (httpClient: HttpClient) => async (jsonData: any[]) => {
    return await httpClient.api('/admin/aspnetusers/bulk', {
      method: 'POST',
      body: JSON.stringify(jsonData),
    });
  };
